<template>
  <div
    v-if="list?.length"
    :ref="(el) => categoryStore.setRubricsRef(el as HTMLElement)"
    class="container wrap"
  >
    <div class="title">Рубрики</div>
    <TagList
      class="tag-list"
      :list="list"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed, watch, ref } from 'vue';
  import { useRoute } from 'vue-router';

  import { getTags, type Tag } from '@/shared/api/experience';
  import { type TagWithActive } from '@/shared/models';
  import TagList from '@/shared/ui/TagList.vue';
  import { useLogger } from '@/shared/utils/logger';
  import { useCategoryStore } from '@/shared/store';

  const categoryStore = useCategoryStore();

  const route = useRoute();
  const logger = useLogger();

  const categorySlug = computed(() => String(route.params.categorySlug ?? ''));
  const list = ref<TagWithActive[]>([]);

  const moveElement = (arr: Tag[]) => {
    let index = arr.findIndex((el) => el.category_slug === categorySlug.value);

    if (index === -1) {
      const allTagIndex = arr.findIndex((el) => el.tag_name === 'Все');

      if (allTagIndex !== -1) {
        index = allTagIndex;
      }
    }

    if (index === -1) {
      return arr;
    }

    const element = arr.splice(index, 1)[0] as TagWithActive;

    element.isActive = true;
    arr.splice(0, 0, element);

    return arr;
  };

  const fetchData = async () => {
    let response;

    try {
      response = await getTags({ path: { categorySlug: categorySlug.value } });
    } catch (e) {
      logger.error(e);
    }

    list.value = moveElement(response?.data ?? []);
  };

  watch(
    categorySlug,
    async () => {
      await fetchData();
    },
    { immediate: true },
  );
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography';
  @use '@experience/shared/dist/assets/adaptivity';

  .container.wrap {
    scroll-margin-top: 70px;
  }

  .title {
    color: var(--alias-color-text-default);

    @include typography.base-700-500-extra;
  }

  .wrap {
    width: 100%;
    max-width: 1260px;
    margin: 32px auto 0;
    padding: 0 20px;

    @include adaptivity.tablet {
      box-sizing: border-box;
    }

    @include adaptivity.mobile {
      margin: 16px 0 0;
      padding: 0;
    }
  }

  .tag-list {
    margin-top: 16px;
  }

  .tag-list,
  .title {
    @include adaptivity.mobile {
      padding: 0 20px;
    }
  }
</style>
